module.exports = __webpack_public_path__ + "img/avatar-lg-symbol.ae0342af.svg";